export default __webpack_public_path__ + "static/media/oe07.ecfa23d2.jpg";